import React from 'react';

function Footer() {
    return (
        <footer className="bg-[#0a0a0a] text-[#7a7873]">
            <div className="shell">
                <div className="h-px bg-white/[0.09]" />
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 py-8">
                    <div className="mono flex items-center gap-6">
                        <span className="text-[#e9e7e2]">Unit 326</span>
                        <span>Builders. Creatives.</span>
                    </div>

                    <div className="mono flex flex-wrap items-center gap-x-6 gap-y-2">
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://twitter.com/Unit_326"
                            className="text-[#7a7873] hover:text-[#e9e7e2] transition-colors no-underline"
                        >
                            Twitter
                        </a>
                        <a
                            href="mailto:hello@unit326.com"
                            className="text-[#7a7873] hover:text-[#e9e7e2] transition-colors no-underline"
                        >
                            Email
                        </a>
                        <span>© {new Date().getFullYear()}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
